import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {IContent} from '../administration/contents/contents';

@Injectable()
export class HomeService {
    constructor(
        private _http: HttpClient
    ) {
    }

    slides(): Observable<IContent[]> {
        return this._http.get<IContent[]>(environment.api + '/slides');
    }

    articles(): Observable<IContent[]> {
        return this._http.get<IContent[]>(environment.api + '/articles');
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/home/home.service.ts